import * as $ from 'jquery';
import {$messageHover} from './message';

let isHover = false;
let dt = null;
let component = null;
let scrollTop = 0;
let scrollLeft = 0;

function postHover() {
  const rect = component.getBoundingClientRect() || {};
  const json = {
    isShow: 1,
    scrollTop: scrollTop,
    scrollLeft: scrollLeft,
    componentId: component.parentNode.dataset.componentId,
    top: rect.top,
    left: rect.left,
    right: rect.right,
    bottom: rect.bottom,
    width: rect.width,
    x: rect.x,
    y: rect.y
  };
  $messageHover(json);
}

export function componentHover() {
  $('.sk-component').children().on('mouseenter', function(ev) {
    isHover = true;
    component = this;
    postHover();
  }).on('mouseleave', (ev) => {
    isHover = false;
    component = null;
    clearTimeout(dt);
    dt = setTimeout(() => {
      if (!isHover) {
        $messageHover({
          isShow: 0, top: 0, left: 0, scrollTop: 0, scrollLeft: 0
        });
      }
    }, 300);
  });
}

$(window).off('.stemplate-hover').on('scroll.stemplate-hover', () => {
  scrollTop = $(document).scrollTop();
  scrollLeft = $(document).scrollLeft();
  if (component) {
    postHover();
  }
});